import styled from 'styled-components';
import FONTS from '../../style/fonts';
import { ListColors } from './typeAhead.types';

const retrieveColorTheme = (style: string, prop: string): string => {
    return ListColors[style][prop];
}

export const styledTypeAheadWrapper = styled.div`
    position: relative;
`;

export const styledListWrapper = styled.ul`
    position: absolute;
    list-style-type: none;
    list-style: none;
    padding: 5px;
    margin:0;
    width: 100%;
    position: absolute;
    background-color: ${props => retrieveColorTheme(props.theme, 'base') };
    top: 42px;
    color: ${props => retrieveColorTheme(props.theme, 'text') };
    border: 1px solid ${props => retrieveColorTheme(props.theme, 'border') };
`;

export const styledListItem = styled.li`
    cursor: pointer;
    background-color: ${props => retrieveColorTheme(props.theme, 'base') };
    font-family: ${FONTS.primaryFont};
    font-size: 15px;
    padding: 5px;
    font-weight: 500;
    &[data-type="label"] {
        font-size: 13px;
        font-weight: 700;
        color: ${props => retrieveColorTheme(props.theme, 'icon') };
        padding-left: 4px;
        text-transform: uppercase;
        &:hover {
            background-color: none;
        }
    }

    &:not([data-type="label"]) {
        &:hover {
            background-color: ${props => retrieveColorTheme(props.theme, 'hover') };
        }
    }

    &.active {
        background-color: ${props => retrieveColorTheme(props.theme, 'hover') };
    }
`;
